export const DEFAULT_AVATARS = [
  'https://res.cloudinary.com/do44szjts/image/upload/v1634546735/teamqsg2i0ok5of8jn8l.png',
  'https://res.cloudinary.com/do44szjts/image/upload/v1634546711/jucmnuo1kbkxukkrjldv.png',
  'https://res.cloudinary.com/do44szjts/image/upload/v1634546753/ovmnmsidhcjverlyca3y.png',
  'https://res.cloudinary.com/do44szjts/image/upload/v1634546774/alemmnrsg65yynecaz7b.png',
];
